export default {
  redeemCode: {
    title: 'コード引き換え',
    description: '以下に引き換えコードを入力して、報酬を受け取ってください。',
    enterTip: '引き換えコードを入力して報酬を受け取る',
    label: '引き換えコード',
    placeholder: '引き換えコードを入力',
    submit: '引き換える',
    redeemBtn: '引き換え',
    submitting: '引き換え中...',
    success: 'コードの引き換えに成功しました！',
    redeemSuccess: 'コードの引き換えに成功しました！',
    failed: 'コードの引き換えに失敗しました。もう一度お試しください。',
    redeemFailed: 'コードの引き換えに失敗しました。もう一度お試しください。'
  }
};
